import { RH } from '@/constants/permissions'

/**
 * El grupo «Reclutamiento» del menú lateral (SRH-310).
 *
 * El proceso estaba repartido en dos grupos que se llamaban casi igual
 * («Reclutamiento» y «Candidatos») y la gente no sabía por dónde seguía. Es un
 * solo grupo, en el orden del proceso, y cada entrada aparece por su propio
 * permiso: un solicitante no tiene el del tablero pero sí entra a las
 * entrevistas con él, y Dirección no tiene el del tablero pero sí decide.
 *
 * El título de cada pantalla es el de su entrada. Si cambia uno, cambia el otro.
 */

export interface EntradaDeReclutamiento {
  id: string
  label: string
  route: string
}

/** `tiene` es la pregunta de permisos del menú: acepta la clave completa. */
export const entradasDeReclutamiento = (
  tiene: (permiso: string) => boolean,
): EntradaDeReclutamiento[] => {
  const esSolicitante = tiene(RH.SOLICITUDES_PERSONAL_CREATE)

  const entradas: Array<EntradaDeReclutamiento | false> = [
    tiene(RH.RECLUTAMIENTO_CANDIDATOS_READ) && {
      id: 'panel-candidatos',
      label: 'Panel de candidatos',
      route: 'rh-dashboard',
    },
    tiene(RH.ENTREVISTAS_READ) && {
      id: 'entrevistas-rh',
      label: 'Entrevistas de RH',
      route: 'hr-interviews',
    },
    (tiene(RH.ENTREVISTAS_CREATE) || esSolicitante) && {
      id: 'entrevistas-solicitante',
      label: 'Entrevistas del solicitante',
      route: 'hiring-manager-interviews',
    },
    // Solo con el permiso de cierre: es quien decide ahí (SRH-304).
    tiene(RH.RECLUTAMIENTO_CERRAR_SELECCION) && {
      id: 'cierre-seleccion',
      label: 'Cierre y selección final',
      route: 'rh/cierre-seleccion',
    },
    // La ve quien consulta y quien decide por Dirección (SRH-283).
    (tiene(RH.RECLUTAMIENTO_CONSULTAR_APROBADOS) ||
      tiene(RH.RECLUTAMIENTO_DECIDIR_APROBADOS)) && {
      id: 'validacion-direccion',
      label: 'Validación de Dirección',
      route: 'rh/validacion-direccion',
    },
  ]

  return entradas.filter((entrada): entrada is EntradaDeReclutamiento => !!entrada)
}
